import React, { useState } from 'react';
import { Box, Container, Typography, Grid2, Card, CardMedia, Button, Tabs, Tab } from '@mui/material';
import sample1 from '../assets/images/sample1.jpeg';
import sample2 from '../assets/images/sample2.jpeg';
import sample3 from '../assets/images/sample3.jpeg';
import sample4 from '../assets/images/sample4.jpeg';
import sample5 from '../assets/images/sample5.jpeg';
import sample6 from '../assets/images/sample6.jpeg';

const Gallery = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (newValue) => {
    setActiveTab(newValue);
  };

  // Gallery images categorized
  const galleryImages = {
    all: [
      { id: 1, url: sample1, category: 'residential', title: 'Home Rewiring' },
      { id: 2, url: sample2, category: 'residential', title: 'Panel Installation' },
      { id: 3, url: sample3, category: 'commercial', title: 'Office Lighting' },
      { id: 4, url: sample4, category: 'commercial', title: 'Commercial Wiring' },
      { id: 5, url: sample5, category: 'industrial', title: 'Factory Electrical' },
      { id: 6, url: sample6, category: 'industrial', title: 'Industrial Panel' },
    ],
    residential: [],
    commercial: [],
    industrial: [],
    team: []
  };

  // Populate category arrays
  galleryImages.residential = galleryImages.all.filter(img => img.category === 'residential');
  galleryImages.commercial = galleryImages.all.filter(img => img.category === 'commercial');
  galleryImages.industrial = galleryImages.all.filter(img => img.category === 'industrial');
  galleryImages.team = galleryImages.all.filter(img => img.category === 'team');

  const categories = [
    { label: 'All Projects', value: 'all' },
  ];

  return (
    <Box>
      {/* Header */}
      <Box 
        className="py-20 text-white text-center"
        sx={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${sample1})`
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h3" component="h1" className="font-bold mb-4">
            Our Project Gallery
          </Typography>
          <Typography variant="h6" className="max-w-2xl mx-auto">
            Browse through our completed electrical projects and see the quality of our work.
          </Typography>
        </Container>
      </Box>
      
      {/* Gallery Section */}
      <Box className="py-16">
        <Container maxWidth="lg">
          {/* Filtering Tabs */}
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 4 }}>
            <Tabs 
              value={activeTab} 
              onChange={handleTabChange} 
              variant="scrollable"
              scrollButtons="auto"
              aria-label="gallery categories"
              sx={{ mb: 2 }}
            >
              {categories.map((category, index) => (
                <Tab key={category.value} label={category.label} id={`gallery-tab-${index}`} />
              ))}
            </Tabs>
          </Box>
          
          {/* Gallery Grid */}
          <Grid2 container spacing={3}>
            {galleryImages[categories[activeTab].value].map((image) => (
              <Grid2 item xs={12} sm={6} md={4} key={image.id}>
                <Card className="overflow-hidden transition-transform duration-300 hover:shadow-lg hover:-translate-y-2">
                  <Box className="relative">
                    <CardMedia
                      component="img"
                      image={image.url}
                      alt={image.title}
                      className="h-64 object-cover"
                    />
                  </Box>
                </Card>
              </Grid2>
            ))}
          </Grid2>
        </Container>
      </Box>
      
      {/* Call to Action */}
      <Box className="py-16 bg-gray-100">
        <Container maxWidth="md" className="text-center">
          <Typography variant="h4" component="h2" className="font-bold mb-4 ">
            Ready to Start Your Project?
          </Typography>
          <Typography variant="body1" className="mb-8 text-gray-700 max-w-2xl mx-auto p-4">
            Whether you need a simple repair or a complete electrical installation, our team of experts is ready to help you.
          </Typography>
          <Button 
            variant="contained" 
            color="primary" 
            size="large"
            className="bg-gray-700 hover:bg-gray-800 mr-4"
            href="/contact"
          >
            Contact Us Now
          </Button>
          {/* <Button 
            variant="contained" 
            color="warning" 
            size="large"
            className="bg-yellow-500 hover:bg-yellow-600"
          >
            Get a Free Quote
          </Button> */}
        </Container>
      </Box>
    </Box>
  );
};

export default Gallery;
